<!--
  ~ Copyright 2022-2023 NXGN Management, LLC. All Rights Reserved.
  -->

<div class="main-row" *ngIf="isWorldPay()">
  <div class="col-md-12">
    <fieldset>
      <legend class="row borderDivide">
        <div class="col-md-6 m-auto borderSeparation">Beneficial Owners</div>
        <div class="col-md-6">
          <ng-container
            *ngIf="
              merchant.accountDetails.worldPayAccountDetails
                .backingWPMerchantExists &&
              ((merchant.accountDetails.worldPayAccountDetails.ownershipType !==
                'Sole Proprietorship' &&
                merchant.accountDetails.worldPayAccountDetails.beneficialOwners
                  .length < 11) ||
                (merchant.accountDetails.worldPayAccountDetails
                  .ownershipType === 'Sole Proprietorship' &&
                  merchant.accountDetails.worldPayAccountDetails
                    .beneficialOwners.length < 1))
            "
          >
            <button
              class="btn btn-primary float-right borderSeparation"
              *ngIf="hasFinanceRole() && isMerchantActive() && !isAddOrEdit()"
              (click)="createOwner()"
            >
              <span>
                <fa-icon [icon]="faPlus"></fa-icon>
              </span>
              Add New Beneficial Owner
            </button>
          </ng-container>
        </div>
      </legend>
      <fieldset
        *ngFor="
          let beneficialOwner of sortOwners(
            merchant.accountDetails.worldPayAccountDetails.beneficialOwners
          );
          let i = index
        "
      >
        <div class="row mt-4" *ngIf="isMerchantActive() && !isAddOrEdit()">
          <h4 class="col-md-6 m-auto">{{ beneficialOwner.ownerType }}</h4>
          <div class="col-md-6">
            <div class="float-right">
              <button
                class="btn btn-primary mr-1"
                *ngIf="
                  merchant.accountDetails.worldPayAccountDetails
                    .backingWPMerchantExists && hasFinanceRole()
                "
                (click)="editOwner(i)"
              >
                <span>
                  <fa-icon [icon]="faEditPencil"></fa-icon>
                </span>
                Edit {{ beneficialOwner.ownerType }}
              </button>
              <button
                *ngIf="
                  merchant.accountDetails.worldPayAccountDetails
                    .backingWPMerchantExists &&
                  hasFinanceRole() &&
                  beneficialOwner.ownerType != 'ControlOwner' &&
                  merchant.accountDetails.worldPayAccountDetails
                    .ownershipType !== 'SoleProprietorship'
                "
                class="btn btn-danger {{
                  deleteBeneficialOwnerInProgress ? 'disabled' : ''
                }}"
                (click)="deleteBeneficialOwner(i, beneficialOwner)"
              >
                <span
                  class="oi oi-x {{
                    deleteBeneficialOwnerInProgress ? 'fa fa-spinner' : ''
                  }}"
                ></span>
              </button>
            </div>
          </div>
        </div>
        <div *ngIf="!isAddOrEdit()" class="mt-3">
          <div class="table-block">
            <div class="recordRow">
              <div class="recordLabel">First Name</div>
              <div id="beneficialOwnerFirstName" class="recordValue">
                {{ beneficialOwner.firstName }}
              </div>
            </div>
            <div class="recordRow">
              <div class="recordLabel">Last Name</div>
              <div id="beneficialOwnerLastName" class="recordValue">
                {{ beneficialOwner.lastName }}
              </div>
            </div>
            <div class="recordRow" *ngIf="hasFinanceRole()">
              <div class="recordLabel">Percent Ownership</div>
              <div id="beneficialOwnerPercent" class="recordValue">
                {{ beneficialOwner.percentOwned }}
              </div>
            </div>
            <div class="recordRow">
              <div class="recordLabel">Title</div>
              <div id="beneficialOwnerTitle" class="recordValue">
                {{ beneficialOwner.title }}
              </div>
            </div>
            <div class="recordRow" *ngIf="hasFinanceRole()">
              <div class="recordLabel">Social Security Number</div>
              <div id="beneficialOwnerSSN" class="recordValue">
                {{ beneficialOwner.ssn }}
              </div>
            </div>
            <div class="recordRow" *ngIf="hasFinanceRole()">
              <div class="recordLabel">Date Of Birth</div>
              <div id="beneficialOwnerDOB" class="recordValue">
                {{ beneficialOwner.dateOfBirth }}
              </div>
            </div>
            <div class="recordRow" *ngIf="hasFinanceRole()">
              <div class="recordLabel">Email</div>
              <div id="beneficialOwnerEmail" class="recordValue">
                {{ beneficialOwner.email }}
              </div>
            </div>
            <div class="recordRow" *ngIf="hasFinanceRole()">
              <div class="recordLabel">Phone Number</div>
              <div id="beneficialOwnerPhoneNumber" class="recordValue">
                {{ beneficialOwner.phoneNumber }}
              </div>
            </div>
            <div class="recordRow" *ngIf="hasFinanceRole()">
              <div class="recordLabel">Address Line 1</div>
              <div id="beneficialOwnerAddress1" class="recordValue">
                {{ beneficialOwner.addressLine1 }}
              </div>
            </div>
            <div class="recordRow" *ngIf="hasFinanceRole()">
              <div class="recordLabel">Address Line 2</div>
              <div id="beneficialOwnerAddress2" class="recordValue">
                {{ beneficialOwner.addressLine2 }}
              </div>
            </div>
            <div class="recordRow" *ngIf="hasFinanceRole()">
              <div class="recordLabel">City</div>
              <div id="beneficialOwnerCity" class="recordValue">
                {{ beneficialOwner.city }}
              </div>
            </div>
            <div class="recordRow" *ngIf="hasFinanceRole()">
              <div class="recordLabel">State</div>
              <div id="beneficialOwnerState" class="recordValue">
                {{ beneficialOwner.state | stateAbrrToName }}
              </div>
            </div>
            <div class="recordRow" *ngIf="hasFinanceRole()">
              <div class="recordLabel">Zip</div>
              <div id="beneficialOwnerZip" class="recordValue">
                {{ beneficialOwner.zipCode }}
              </div>
            </div>
            <div class="recordRow" *ngIf="hasFinanceRole()">
              <div class="recordLabel">Country</div>
              <div id="beneficialOwnerCountry" class="recordValue">
                {{ beneficialOwner.country }}
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset *ngIf="isAddOrEdit()">
        <div class="row mt-4">
          <h4 class="col-md-6 m-auto">
            {{
              editable
                ? ownerForm.get("ownerType")?.value
                : "Create Beneficial Owner"
            }}
          </h4>
          <div class="col-md-6"></div>
        </div>
        <form
          name="generalInfoFormControl"
          (submit)="updateBeneficialOwner()"
          class="form-horizontal"
          novalidate
          [formGroup]="ownerForm"
        >
          <app-beneficial-owner-edit
            [merchant]="merchant"
            [parentGroup]="ownerForm"
          ></app-beneficial-owner-edit>
          <div class="row mt-2">
            <fieldset class="col-md-12">
              <div class="float-right">
                <button
                  type="button"
                  class="btn btn-light mr-1"
                  (click)="cancelChanges()"
                >
                  <fa-icon [icon]="faTrash"></fa-icon>
                  Cancel Changes
                </button>
                <button
                  type="submit"
                  class="btn btn-primary"
                  [disabled]="actionInProgress || !ownerForm.valid"
                >
                  <span
                    *ngIf="actionInProgress"
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  {{
                    editable
                      ? "Update Beneficial Owner"
                      : "Create Beneficial Owner"
                  }}
                </button>
              </div>
            </fieldset>
          </div>
        </form>
      </fieldset>
    </fieldset>
  </div>
</div>
